module.exports = __webpack_public_path__ + "img/title.8ba2a18c.svg";